import { FormikProps } from 'formik';

import { OODocumentPartModel } from '@features/oneOnboarding/models/DocumentPartModel';

interface FileUploadProps {
  props: FormikProps<any>;
  part: OODocumentPartModel;
  controls: any[];
  onInvalidFileChoose: (validationResult: any) => void;
  validateFile: (file: File) => { valid: boolean; message?: string };
  setState: React.Dispatch<React.SetStateAction<any>>;
  setIsFileReuploaded?: React.Dispatch<React.SetStateAction<boolean>>;
  validateField?: boolean;
}

export const FileUpload: React.FC<FileUploadProps> = ({
  props,
  part,
  controls,
  onInvalidFileChoose,
  validateFile,
  setState,
  validateField = false,
  setIsFileReuploaded,
}) => {
  const handleFileSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const fileValidationResult = validateFile(file);
    if (!fileValidationResult.valid) {
      onInvalidFileChoose(fileValidationResult);
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      props.setFieldValue(part.name, e.target!.result);

      if (validateField) {
        props.validateField(part.name);
      }

      const fileUrl = URL.createObjectURL(file);

      setState((prevState: any) => {
        const updatedState = { ...prevState };

        controls.forEach((c: any) => {
          if (props.values[c.name]) {
            updatedState[c.name] = props.values[c.name];
          }
        });

        updatedState[part.name] = { ...updatedState[part.name], file, data: fileUrl };

        return updatedState;
      });
    };

    reader.readAsDataURL(file);
  };

  return (
    <input
      accept="image/*, application/pdf"
      id={`btn-upload-${part.name}`}
      name={part.name}
      style={{ display: 'none' }}
      type="file"
      onChange={(event) => {
        setIsFileReuploaded?.(true);
        handleFileSelection(event);
      }}
    />
  );
};
